module.exports = __webpack_public_path__ + "static/media/midi.9fb7e445.svg";